import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@/components/ui/utils';

const styles = cva('py-1 px-3 rounded-full border text-sm', {
  variants: {
    color: {
      primary: 'bg-primary/10 text-primary border-primary',
      success: 'bg-success/10 text-success border-success',
      destructive: 'bg-destructive/10 text-destructive border-destructive',
      disabled: 'bg-muted text-muted-foreground border-muted-foreground',
      secondary: 'bg-secondary text-secondary-foreground border-secondary-foreground',
      amber: 'bg-amber-600/10 text-amber-600 border-amber-600',
    },
  },
  defaultVariants: {
    color: 'primary',
  },
});

export type TappPillProps = {} & VariantProps<typeof styles> & React.ComponentProps<"span">;

export const TappPill: React.FC<TappPillProps> = ({ color, className, ...props }) => {
  return <span className={cn(styles({ color }), className)} {...props} />;
};
